import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const EASE = [0.76, 0, 0.24, 1];

const CATEGORIES = [
  {
    id: "sedan",
    tag: "Category 01 — Sedan",
    name: "Honda Amaze",
    img: "https://static.prod-images.emergentagent.com/jobs/354cc0d6-5b57-438b-8557-1a7d83c8045e/images/592b016e72ec4d4700bd3283ebdc03565e619a0d52f854abf7ba9b7065e82277.jpeg",
    flip: false,
    rows: [
      { journey: "Local Intercity", journeyType: "Local Intercity", detail: "City runs under 300 km", price: "₹1,000 / DAY · ₹12 / KM" },
      { journey: "Long Distance", journeyType: "Long Distance Journey", detail: "Toll, parking, border, etc. extra", price: "₹14 / KM" },
      { journey: "Hourly Rental", journeyType: "Hourly Rental", detail: "Km or hour, both counted — the higher is charged", price: "₹30 / KM · ₹300 / HR" },
      { journey: "Airport to Airport", journeyType: "Airport Transfer", detail: "Fixed quote per trip", price: "ON REQUEST" },
    ],
  },
  {
    id: "ertiga",
    tag: "Category 02 — SUV",
    name: "Maruti Ertiga",
    img: "https://static.prod-images.emergentagent.com/jobs/354cc0d6-5b57-438b-8557-1a7d83c8045e/images/3b9ef91a8527bd531776d529004d29435e1a3c62741aa2ed010abaaaa136b334.jpeg",
    flip: true,
    rows: [
      { journey: "Local Intercity", journeyType: "Local Intercity", detail: "City runs under 300 km", price: "₹1,500 / DAY · ₹12 / KM" },
      { journey: "Long Distance", journeyType: "Long Distance Journey", detail: "Toll, parking, border, etc. extra", price: "₹15 / KM" },
      { journey: "Hourly Rental", journeyType: "Hourly Rental", detail: "Km or hour, both counted — the higher is charged", price: "₹45 / KM · ₹450 / HR" },
      { journey: "Airport to Airport", journeyType: "Airport Transfer", detail: "Fixed quote per trip", price: "ON REQUEST" },
    ],
  },
  {
    id: "innova",
    tag: "Category 03 — SUV",
    name: "Toyota Innova",
    img: "https://static.prod-images.emergentagent.com/jobs/354cc0d6-5b57-438b-8557-1a7d83c8045e/images/eec1402a02fa58966b6713d04fbd8930418783c76d8687d5e8e64158d3ba86b6.jpeg",
    flip: false,
    rows: [
      { journey: "Local Intercity", journeyType: "Local Intercity", detail: "City runs under 300 km", price: "₹1,800 / DAY · ₹12 / KM" },
      { journey: "Long Distance", journeyType: "Long Distance Journey", detail: "Toll, parking, border, etc. extra", price: "₹18 / KM" },
      { journey: "Hourly Rental", journeyType: "Hourly Rental", detail: "Km or hour, both counted — the higher is charged", price: "₹55 / KM · ₹550 / HR" },
      { journey: "Airport to Airport", journeyType: "Airport Transfer", detail: "Fixed quote per trip", price: "ON REQUEST" },
    ],
  },
  {
    id: "crysta",
    tag: "Category 04 — SUV",
    name: "Toyota Innova Crysta",
    img: "/crysta-photo.jpg",
    flip: true,
    rows: [
      { journey: "Outstation", journeyType: "Long Distance Journey", detail: "Toll, parking, etc. extra", price: "₹22 / KM" },
      { journey: "Local Intercity", journeyType: "Local Intercity", detail: "8 km per litre · city runs under 300 km", price: "₹2,200 / DAY" },
      { journey: "Hourly Rental", journeyType: "Hourly Rental", detail: "Includes 10 km", price: "₹550 / HR" },
    ],
  },
];

function CategoryCard({ c, i, onBook }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.65, ease: EASE }}
      data-testid={`fleet-category-${c.id}`}
      className="border border-white/10 bg-surface grid lg:grid-cols-12"
    >
      <div className={`relative overflow-hidden lg:col-span-5 ${c.flip ? "lg:order-2" : ""}`}>
        <img
          src={c.img}
          alt={`White ${c.name}`}
          loading="lazy"
          className="w-full h-60 sm:h-72 lg:h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-surface/60 via-transparent to-transparent" />
      </div>
      <div className={`lg:col-span-7 p-6 md:p-10 flex flex-col ${c.flip ? "lg:order-1" : ""}`}>
        <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-signal mb-2">{c.tag}</p>
        <h3 className="font-display uppercase text-3xl md:text-4xl mb-6">{c.name}</h3>
        <div className="flex flex-col">
          {c.rows.map((r) => (
            <button
              key={r.journey}
              data-testid={`fleet-book-${c.id}-${r.journey.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => onBook(r.journeyType)}
              className="group flex flex-col sm:flex-row sm:items-center justify-between gap-1 sm:gap-6 text-left border-t border-white/10 py-4 px-2 -mx-2 hover:bg-white/5 transition-colors duration-200"
            >
              <span>
                <span className="block text-sm md:text-base font-semibold text-bone">{r.journey}</span>
                <span className="block text-xs text-zinc-500 mt-0.5">{r.detail}</span>
              </span>
              <span className="flex items-center gap-3 shrink-0">
                <span className="font-mono text-signal text-sm md:text-base">{r.price}</span>
                <ArrowRight size={15} className="text-signal opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
              </span>
            </button>
          ))}
        </div>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-5">
          Tap any fare to book that ride
        </p>
      </div>
    </motion.article>
  );
}

export default function Fleet({ onBook }) {
  return (
    <section id="fleet" className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
      <div className="mb-14 md:mb-20 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-signal mb-4">(02) — The fleet</p>
          <h2 className="font-display font-black uppercase leading-[0.95] text-4xl sm:text-5xl lg:text-6xl">
            Pick your
            <br />
            machine.
          </h2>
        </div>
        <p className="max-w-sm text-zinc-400 leading-relaxed text-base">
          A sedan, an Ertiga, an Innova and an Innova Crysta — four
          categories, every fare fixed and upfront. Tap a rate to book that
          exact ride.
        </p>
      </div>

      <div className="flex flex-col gap-8 md:gap-10">
        {CATEGORIES.map((c, i) => (
          <CategoryCard key={c.id} c={c} i={i} onBook={onBook} />
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-10 border-t border-white/10 pt-12 mt-16 md:mt-24">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-signal mb-3">Hourly rentals</p>
          <p className="text-zinc-400 leading-relaxed">
            Sedan ₹30/km · ₹300/hr, Ertiga ₹45/km · ₹450/hr, Innova ₹55/km ·
            ₹550/hr. Kilometres or hours — both are counted, and the bigger
            number is what you pay. The meter never lies, and neither do we.
          </p>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-signal mb-3">The fine print</p>
          <p className="text-zinc-400 leading-relaxed">
            Long-distance fares exclude toll, parking, border and permit
            charges — those are billed at actuals. What we quote is what you
            see on the windscreen.
          </p>
        </div>
      </div>
    </section>
  );
}
